/**
 * @generated SignedSource<<a555ce5433d182c62368127624bd5b47>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedRecentlySoldItems_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentType": "SbSharedRecentlySoldItems_user";
};
export type SbSharedRecentlySoldItems_user$key = {
  readonly " $data"?: SbSharedRecentlySoldItems_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedRecentlySoldItems_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedRecentlySoldItems_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "2056dc2a11be6a6f0f9a200f3e6c3bbf";

export default node;
